<template>
  <div>
    <b-card>
      <loading :active.sync="isLoading">
      </loading>

      <div class="card-header">
        <h3>Survey Details</h3>
      </div>
      <b-form class="card-body" v-if="survey" @submit.prevent="submit">
        <b-form-group label="Title" label-for="title-input">
          <b-form-input id="title-input" :disabled="!isEditable()" type="text" v-model="survey.title"></b-form-input>
        </b-form-group>
        <b-form-group label="Client name" label-for="title-input">
          <b-form-input id="title-input" :disabled="!isEditable()" type="text" v-model="survey.clientName"></b-form-input>
        </b-form-group>
        <b-form-group label="Description" label-for="desc-input">
          <b-form-textarea :disabled="!isEditable()" v-model="survey.description"></b-form-textarea>
        </b-form-group>
        <b-form-group label="Survey Type" style="width: 100px;" label-for="desc-input">
                <b-form-select id="type" v-model="survey.type" :disabled="true">
                <template>
                    <option value="visualize" selected>visualize</option>
                    <option value="survey">survey</option>
                </template>
                </b-form-select>
            </b-form-group>
        <b-form-group label="Sequence number" label-for="desc-input" v-if="survey.type == 'visualize'">
          <b-form-input id="title-input" :disabled="!isEditable()" style="width: 5rem; text-align: center" type="text"
            v-model="survey.seq"></b-form-input>
        </b-form-group>
        <b-form-group label="Survey period" label-for="desc-input">
          <div>
            <b-input-group class="form-inline w-25" style="float: left">
              <b-form-input id="example-input" v-model="survey.startDate" :disabled="true" type="text"
                placeholder="Choose a Start date"></b-form-input>
              <b-input-group-append>
                <b-form-datepicker v-model="survey.startDate" :disabled="!isEditable()" button-only right
                  aria-controls="example-input"></b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
            <h3 style="float: left">~</h3>
            <b-input-group class="form-inline w-25">
              <b-form-input id="example-input" v-model="survey.endDate" :disabled="true" type="text"
                placeholder="Choose a End date"></b-form-input>
              <b-input-group-append>
                <b-form-datepicker v-model="survey.endDate" :disabled="!isEditable()" button-only right
                  aria-controls="example-input"></b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-form-group>

        <b-form-group v-if="survey.attachedFilename != null" label="Files" label-for="none">
          <div class="p-1 d-flex justify-content-between align-items-center" :disabled="!isEditable()">
            {{ survey.attachedFilename }}
            <b-input-group-append>
              <b-badge v-if="isEditable()" role="button" class="mr-2" variant="primary" @click="downloadSurvey(survey.surveyId, survey.attachedFilename)
                ">Download</b-badge>
              <b-badge v-if="isEditable()" role="button" variant="danger" @click="deleteFile()">Delete</b-badge>
            </b-input-group-append>
          </div>
        </b-form-group>

        <b-form-group v-if="survey.attachedFilename == null" label="Add a file" label-for="file-input">
          <b-form-file ref="file-input" id="file-input" @input="addFile" v-model="file"
            placeholder="Choose a file or drop it here" drop-placeholder="Drop a file here"></b-form-file>
        </b-form-group>

        <!-- Invitation Table -->
        <!-- <b-form-group  label="Invitation Code" label-for="url-copy">
          <b-input-group>
            <b-input-group-prepend >
              <b-button class="btn btn-secondary" style="position: relative;"  @click="copyUrl()"  v-b-tooltip.hover title="Copy">
                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" class="bi bi-file-earmark-text" viewBox="0 0 16 16" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"> <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"></path> <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"></path> </svg>
              </b-button>
            </b-input-group-prepend>
            <b-form-input aria-label="URL" style="width:60%; background-color: white;" v-model="url" disabled></b-form-input>
            <b-form-input aria-label="Expiration date"  style="width:10%; font-weight: bold;  " v-model="expirationDate" disabled></b-form-input>
          </b-input-group>
        </b-form-group>  -->
        <!-- / Invitation Table -->
        <!-- TESTTESTTEST -->
        <b-form-group label="Invitation Code" label-for="url-copy" v-if="survey.type == 'visualize'">
          <table class="table table-bordered  shadow-sm mt-2" >
            <colgroup>
              <col width="5%"/>
              <col width="80%"/>
              <col width="15%"/>            
            </colgroup>
            <thead>
            <tr class="text-center table-dark">
              <th>Copy</th>
              <th>URL</th>
              <th>Expiration Date</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in secretKeyList" :key="item.key">
              <td class="text-center" @click="copyUrl(item.url)" style="position: relative;">
                <b-icon icon="clipboard-check"  style="font-size: 1.5em; color: DimGray;"></b-icon>
              </td>
              <td class="text-left">{{ item.url }}</td>
              <td class="text-center">{{ item.expirationDate }}</td>
            </tr>
            </tbody>
          </table>
        </b-form-group>
        <b-form-group label="Send Mail" label-for="none" v-if="survey.type == 'survey'" class="mb-5">
			    <b-button class="mr-1" style="height:auto;" variant="outline-info" size="sm" @click="sendMail">Send Mail</b-button>
			    <b-button class="mr-1" style="height:auto;" variant="outline-info" size="sm"  @click="openResultModal">전송 결과</b-button>
        </b-form-group>
        <!-- /TESTTESTTEST -->

        <!-- Buttons -->
        <b-button v-if="isEditable()" @click="updateSurvey" variant="primary" class="mr-1">Update</b-button>
        <b-button @click="visualizeSurvey" variant="danger" class="mr-1" v-if="survey.type == 'visualize'">Visualize</b-button>
        <b-button @click="excelExport" variant="success" class="mr-1" v-if="survey.type == 'survey'">Export</b-button>
        <b-button @click="cancel" type="button">Close</b-button>
        <b-button v-if="hasAnyRole('Supervisor', 'Administrator') && survey.type == 'visualize'" @click="makeInvitationCode" type="button"
          style="float: right">Make invitation code</b-button>
        <!-- /Buttons -->
      </b-form>

    </b-card>

    <!-- Message modal -->
    <b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary" ok-title="Close">
      <p class="my-4 text-center">{{ msgContent }}</p>
    </b-modal>
    <!-- /Message modal -->
    <!-- 전송 결과 modal-->
    <b-modal size="lg" ref="resultModal" scrollable header-class="detail-header" title="메일 전송 결과" 
            @cancel.prevent="sendMailToReceiver" cancel-variant="outline-info" cancel-title="재전송"
            ok-title="Close" ok-variant="secondary">
      <table class="table table-bordered table-hover shadow-sm mt-2">
        <thead class="script-header" >
          <tr class="text-center">
              <th><b-form-checkbox v-model="allSelected" @change="checkAll"></b-form-checkbox></th>
              <th>user</th>
              <th>설문 완료 여부</th>
              <th>메일 전송 성공/실패 여부</th>
              <th>실패 사유</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(sendResult, idx) in sendMailResultList" :key="idx" class="text-center">
            <td><b-form-checkbox v-model="receiverList" :value="sendResult.userMail"></b-form-checkbox></td>
            <td>{{sendResult.userMail}}</td>
            <td>{{sendResult.completeYn}}</td>
            <td>{{sendResult.sendStatus}}</td>
            <td>{{sendResult.failReason}}</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
  props: { id: { type: String, default: "-1" } },
  components: { Loading, },
  data() {
    return {
      survey: null,
      file: null,
      isLoading: false,
      msgStatus: "",
      msgContent: "",
      secretKeyList: [],
      sendMailResultList: [],
      receiverList: [],
      allSelected: false,
      secretKey: {
        url: '',
        expirationDate: '',
      },
    };
  },
  methods: {
    isEditable() {
      return this.hasAnyRole('Supervisor', 'Administrator');
    },
    showMessage(status, message) {
      this.msgStatus = status;
      this.msgContent = message;
      this.$bvModal.show("messageModal");
    },
    showErrorMessage(error) {
      if (error.status != 401) {
        this.showMessage(
          error.status == 200 ? error.code : error.status,
          error.message
        );
      }
    },
    async setInvitationCode() {
      this.secretKeyList = []
      try {
        this.isLoading = true;

        let response = await axios.post(
          `survey/selectSurveySecret/${this.id}`, {}, {
          baseURL: WORKMAN_URL,
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        });
        response.data.forEach(item => {
          let secretKey= {
            url: '',
            expirationDate: '',
          }
          secretKey.url = ("https://spaders.net/survey/" + this.survey.surveyId +"/visualize/" + item.secret);
          secretKey.expirationDate = item.expirationDate;
          this.secretKeyList.push(secretKey);
        });
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    async makeInvitationCode() {
      try {
        this.isLoading = true;

        let response = await axios.post(
          `survey/addSurveySecret/${this.id}`, {}, {
          baseURL: WORKMAN_URL,
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          },
        });

        // If there's no data, throw an error
        if (!response.data) {
          throw new Error("초대코드 생성에 실패했습니다.")
        }else{
          this.setInvitationCode();
        }

        
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateSurvey() {
      //  본인 또는 관리자만 수정 가능하도록 visible 설정 > 현재 Supervisor 만 수정 가능하도록 함.
      try {
        this.isLoading = true;

        if (!this.survey) {
          throw new Error("설문조사 결과가 존재하지 않습니다.");
        }

        // Create formData
        let data = new FormData();
        data.append("surveyId", this.survey.surveyId);
        data.append("title", this.survey.title);
        data.append("clientName", this.survey.clientName);
        data.append("description", this.survey.description);
        data.append("seq", this.survey.seq);
        data.append("startDate", this.survey.startDate);
        data.append("endDate", this.survey.endDate);
        data.append("type", this.survey.type);

        // Case 1: the attached file has been changed
        if (this.survey.file) {
          // Set attached to true
          data.append("attached", true);
          // Append the new file info
          data.append("file", this.survey.file);
        } else {
          // Set attached to false
          data.append("attached", false);
          // Case 2: the existing file has been deleted and there is no newly added file
          if (!this.survey.attachedFilename) {
            throw new Error('파일을 첨부해주세요');
          } else {
            // Case 3: Else, append a dummy file to make the content type 'multipart'
            data.append("file", new File([""], 'dummy.txt'));
          }
        }

        // Submit a new survey
        await axios.post("survey/updateSurvey", data, {
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
            "Content-Type": "multipart/form-data",
          },
        });

        // Reset and redirect
        this.reset();
        this.$router.push("/survey");
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    addFile() {
      if (!this.file) return;

      // Clone the file input
      const original = this.file;
      const clone = new File([original], original.name, {
        type: original.type,
        lastModified: original.lastModified,
      });
      this.survey.file = clone;
      this.survey.attachedFilename = original.name;

      this.$refs["file-input"].reset();
    },
    deleteFile() {
      this.survey.file = null;
      this.survey.attachedFilename = null;
      this.survey.attachedFilePath = null;
    },
    async loadSurvey() {
      
      try {
        this.isLoading = true;

        let response = await axios.post('survey/selectSurvey/' + this.id, {}, {
          baseURL: WORKMAN_URL,
          headers: {
            Accept: "application/json",
            Authorization: accessToken(),
          }
        });

        this.survey = response.data;
        
      } catch (error) {
        if (error.status != 401) {
          this.showMessage(
            error.status == 200 ? error.code : error.status,
            error.message
          );
        }
      } finally {
        this.isLoading = false;
      }
    },
    downloadSurvey(surveyId, attachedFilename) {
      axios({
        method: "POST",
        url: "survey/download/" + surveyId,
        responseType: "blob",
        headers: {
          // "Content-Type": "application/json"
          Accept: "application/json",
          Authorization: accessToken(),
        },
      }).then(response => {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: response.headers["content-type"] })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", attachedFilename + ".zip");
        document.body.appendChild(link);
        link.click();
      });
    },
    visualizeSurvey() {
      this.$router.push("/survey/" + this.id + "/visualize");
    },
    reset() {
      this.survey = null;
      this.file = null;
      this.isLoading = false;
      this.msgStatus = "";
      this.msgContent = "";
    },
    cancel() {
      this.reset();
      this.$router.push("/survey");
    },
    copyUrl(url){
      navigator.clipboard.writeText(url);
      this.showMessage(0, "초대코드가 복사 되었습니다.");
    }, 
    sendMailToReceiver() {
      if(this.receiverList.length == 0) {
        this.showMessage(0, "메일 수신인을 선택해주세요.");
        return;
      }
      this.sendMail();
    },
    async sendMail() {
      await axios.post('survey/sendMail',
      {surveyId: this.id, targetList:this.receiverList},
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': accessToken()
        }
      }).then(response => {
        this.showMessage(0, "메일 전송이 완료 되었습니다.");
      }).catch(e => {
        this.showErrorMessage(e);
      });
    },
    async openResultModal() {
      await axios.post('survey/retrieveSendMailResult',
      {surveyId: this.id},
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': accessToken()
        }
      }).then(response => {
        this.sendMailResultList = response.data;
        this.$refs['resultModal'].show();
      });
    },
    async excelExport() {
      await axios.post('/code/runSnippet/files/survey_db_to_excel/1.0',
      { surveyId: this.id },
      { headers: {Authorization: accessToken(),},
      }).then(response => {
        const base64Data = response.data.files[0];

        const fileName = 'Ex Survey Result.xlsx';
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE 및 Microsoft Edge 브라우저에서 다운로드
          window.navigator.msSaveOrOpenBlob(base64Data, fileName);
        } else {
          // 다른 모든 브라우저에서 다운로드
          const link = document.createElement('a');
          const url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + (base64Data);
          link.href = url;
          link.download = fileName;
          link.click();
        }
      });
    }, 
    checkAll(checked) {
      checked ? this.sendMailResultList.forEach((item) => this.receiverList.push(item.userMail)) :  this.receiverList = [];
    }
  },
  async created() {
    await this.loadSurvey();
    this.setInvitationCode();
  }
};
</script>

<style scoped></style>
